import queryString from 'query-string';

/**
 * Returns the value for the requested name in the query string
 * @param  {String} name Query String Key
 * @return {String}      Query String Value
 */
export function queryParam(name) {
  let query = queryString.parse(location.search);
  return query[name];
}
